import React from 'react';

import { useSearchParams } from 'react-router-dom';

import { AdvisorErrorPage } from '../../../../Shared/Components/AdvisorErrorPage';
import { PendingActionErrorPageStepProps } from '../types';

export const PendingActionErrorPage: React.FC<PendingActionErrorPageStepProps> = ({ flowState }) => {
  const { returnToPath } = flowState;
  const [searchParams] = useSearchParams();
  const assetTicker = searchParams.get('assetTicker') || '';
  return (
    <AdvisorErrorPage
      returnAddress={returnToPath}
      headerText={`Sell ${assetTicker}`}
      titleText="Trading is temporarily unavailable"
      bodyText="Trading is temporarily unavailable for the selected account. This may be due to a pending rebalance, migration, or other account restrictions. Please try again once all pending actions are complete, or contact our support team if the issue persists."
    />
  );
};
